import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import PrimaryNav from "./components/PrimaryNav";
import routes from "./routes";
import { useFormik } from "formik";

const Body = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("reservation")}
      beforeCapture={scope => {
        scope.setTag("module", "reservation");
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

const Reservation = props => {
  const formik = useFormik({
    initialValues: {},
  });
  return (
    <>
      <PrimaryNav formik={formik} />
      <Body {...props} formik={formik} />
    </>
  );
};

export default Reservation;
